import React from 'react'

import loaderGif from '../assets/images/dashboard/animacion de carga_dashboard.gif'
import { LinearProgress } from '@mui/material'

const Loader = ({progress}) => {
  return (
    <div id='loader_container' style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px'}}>
        <img src={loaderGif} alt='Cargando' style={{height: '3rem'}}></img>
        {progress !== null ? <LinearProgress variant="determinate" value={progress} sx={{position: 'absolute', bottom: 0, width: '100%'}} /> : ''}
    </div>
  )
}

export default Loader